import "./GeneralNavbar.css";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";

import { AuthContext } from "@contexts/AuthContext";
import { logoutAuth } from "@libs/apiRequest.js";
import CustomBreadcrumb from "@common-components/CustomBreadcrumb/CustomBreadcrumb";

const GeneralNavbar = () => {
  const navigate = useNavigate();
  const { currentUser, currentUserRole, updateUser } = useContext(AuthContext);

  return (
    <nav className="GeneralNavbar__container">
      <Link to="/" className="GeneralNavbar__logo--link">
        {currentUserRole === "SALES" ||
        currentUserRole?.startsWith("SALES_") ? (
          <img
            src={`${process.env.PUBLIC_URL}/logo/MattamyLogo.svg`}
            alt="Mattamay Homes Logo"
            className="GeneralNavbar__logo--MattamyImg"
          />
        ) : currentUserRole ? (
          <img
            src={`${process.env.PUBLIC_URL}/logo/BIMstudioLogo.svg`}
            alt="BIMstudio Logo"
            className="GeneralNavbar__logo--BIMstudioImg"
          />
        ) : (
          <div className="GeneralNavbar__logo--placeholder"></div>
        )}
      </Link>

      <CustomBreadcrumb LinkPath="/home" BreadcrumbName="Home" />
      {currentUser ? (
        <LogoutIcon
          className="GeneralNavbar__button--logout"
          onClick={async () => {
            logoutAuth();
            await updateUser("");
            localStorage.removeItem("projectSelection");
            localStorage.removeItem("modelSelection");
            localStorage.removeItem("user");
            navigate("/home/login");
          }}
        />
      ) : (
        <LoginIcon
          className="GeneralNavbar__button--login"
          onClick={() => navigate("/home/login")}
        />
      )}
    </nav>
  );
};

export default GeneralNavbar;
